const mutations = {
  SAVE_DETAILS: (state, details) => {
    state.dialerData = details;
  }
};

export default {
  mutations
};
